import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

export default function UploadDataSpinner() {
    return (
        <div className="card " >
            <ProgressSpinner style={{width: '50px', height: '50px' , marginLeft:'50%'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
        </div>
    );
}